import { Component } from '@angular/core';

@Component({
    selector: 'app-panel-title',
    template: '<ng-content></ng-content>'
})
export class PanelTitleComponent {

}
